/* eslint-disable react/prop-types */
/* eslint-disable simple-import-sort/imports */
import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import { styled } from 'styled-components';

import { v2 } from '../v2';

const Base = styled(motion.a)`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 32px;
  border-radius: 100px;
  font-family: ${v2.fontBody};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  white-space: nowrap;
  transition:
    box-shadow 0.3s ease,
    background 0.3s ease,
    border-color 0.3s ease;

  svg {
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;

const PrimaryBase = styled(Base)`
  color: #fff;
  background: ${v2.gradientBtn};
  box-shadow:
    0 8px 32px rgba(30, 150, 252, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);

  &:hover {
    box-shadow:
      0 12px 48px rgba(30, 150, 252, 0.55),
      inset 0 1px 0 rgba(255, 255, 255, 0.25);
  }
`;

const GhostBase = styled(Base)`
  color: ${v2.text};
  background: ${v2.surface};
  border: 1px solid ${v2.borderStrong};
  backdrop-filter: blur(12px);

  &:hover {
    background: ${v2.surfaceHover};
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

export const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M5 12h14m0 0-6-6m6 6-6 6"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const useMagnetic = (strength = 0.25) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 200, damping: 16 });
  const sy = useSpring(y, { stiffness: 200, damping: 16 });

  const onMouseMove = (event) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    x.set((event.clientX - rect.left - rect.width / 2) * strength);
    y.set((event.clientY - rect.top - rect.height / 2) * strength);
  };

  const onMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return { ref, style: { x: sx, y: sy }, onMouseMove, onMouseLeave };
};

export const PrimaryButton = ({ children, withArrow = true, ...rest }) => {
  const magnetic = useMagnetic();
  return (
    <PrimaryBase {...magnetic} whileTap={{ scale: 0.97 }} {...rest}>
      {children}
      {withArrow && <ArrowIcon />}
    </PrimaryBase>
  );
};

export const GhostButton = ({ children, ...rest }) => (
  <GhostBase whileTap={{ scale: 0.97 }} {...rest}>
    {children}
  </GhostBase>
);
